import { List } from 'immutable';
import { makeCreateAction } from 'web-app/util/redux/action-helpers';
export const createActions = (domain, apiDescription, dispatch, isDevelopment) => {
    const createAction = makeCreateAction(dispatch, isDevelopment);
    const internalActions = {
        save: createAction(`${domain}/save`, obj => obj).action,
    };
    if (!apiDescription) {
        return { internalActions };
    }
    const wronglyTypedActionsBundle = List(Object.keys(apiDescription)).map(key => {
        const actions = createAction(`${domain}/${key.toUpperCase()}`, obj => obj, (response, originalPayload) => ({ response, originalPayload }), (error, originalPayload) => ({ error, originalPayload }), originalPayload => ({ originalPayload }));
        return {
            [key]: {
                start: actions.action,
                success: actions.success,
                failed: actions.failed,
                aborted: actions.aborted,
            },
        };
    });
    // This type cast is needed until we find a proper way of iterating the keys of the apiDescription, which throws away type info
    const externalActionsBundleDeep = wronglyTypedActionsBundle;
    return externalActionsBundleDeep.reduce((actions, actionsMap) => {
        return {
            ...actionsMap,
            ...actions,
        };
    }, { internalActions });
};
